'use client';

import { ErrorState } from '@/components/common/ErrorState/ErrorState';
import { GlobalFooter } from '@/components/features/GlobalFooter/GlobalFooter';
import { GlobalHeader } from '@/components/features/GlobalHeader/GlobalHeader';
import { datadogRum } from '@datadog/browser-rum';
import { useTranslations } from 'next-intl';
import { useEffect } from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useTranslations('common.globalError');

  useEffect(() => {
    datadogRum.addError(error);
  }, [error]);

  return (
    <>
      <div className="flex flex-col min-h-screen">
        <GlobalHeader className="sticky top-[0px]" />
        <main className="flex-1 py-16">
          <ErrorState
            title={t('title')}
            body={t('body')}
            action={{
              label: t('action.label'),
              onClick: () => reset(),
            }}
          />
        </main>
        <GlobalFooter />
      </div>
    </>
  );
}
